"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgChevronLeft(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M17.504.201a.766.766 0 011.113 1.047l-.078.083-11.64 10.668 11.64 10.67c.283.26.327.684.117.994l-.07.089a.766.766 0 01-.993.117l-.09-.07L5.249 12.565a.766.766 0 01-.076-1.05l.076-.08L17.504.201z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgChevronLeft;
exports.default = _default;